import { render, staticRenderFns } from "./Quadratic.vue?vue&type=template&id=1ab882f2&"
import script from "./Quadratic.vue?vue&type=script&lang=js&"
export * from "./Quadratic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports